import { Flex, Text } from '@radix-ui/themes'
import { JSX } from 'react'
import { FormErrors } from './form'

export const FieldError = ({ errors, path }: { errors: FormErrors; path: string }) => {
  if (!errors[path]) {
    return null
  }
  return (
    <Text size="1" color="red">
      {errors[path]}
    </Text>
  )
}

export const Field = ({
  label,
  hint,
  children,
}: {
  label: string
  hint?: string
  children: JSX.Element | JSX.Element[]
}) => (
  <Flex direction="column" gap="1">
    <Text size="2" weight="medium">
      {label}
    </Text>
    {children}
    {hint ? (
      <Text size="1" color="gray">
        {hint}
      </Text>
    ) : null}
  </Flex>
)
